import { render, staticRenderFns } from "./company-more-page.vue?vue&type=template&id=0cea7656&"
import script from "./company-more-page.vue?vue&type=script&lang=ts&"
export * from "./company-more-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports